module.exports = __webpack_public_path__ + "static/media/logo_white.54010c7c.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/logos/logo_white.png
// module id = 4416
// module chunks = 0